module.exports = __webpack_public_path__ + "img/phone_feature.2aeddd32.png";